import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWebassemblyComponent } from './simple-icons-webassembly.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWebassemblyComponent ],
    exports:      [ SimpleIconsWebassemblyComponent ],
    bootstrap:    []
})
export class SimpleIconsWebassemblyModule {}
